<template>
  <div class="table-tag">
    <el-tag v-for="(item, index) in list" :type="isHave(item)" :key="index" size="mini">{{
      item.label
    }}</el-tag>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MyTableTag',
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    list: {
      type: Array,
      default: () => {
        return [
          {
            label: i18n.t('HT.options.env2'),
            value: 'TEST'
          },
          {
            label: i18n.t('HT.options.env3'),
            value: 'PRE'
          },
          {
            label: i18n.t('HT.options.env4'),
            value: 'RELEASE'
          }
        ];
      }
    }
  },

  methods: {
    /**
     * 判断是否存在
     * @param {Object} item 判断的数据
     */
    isHave(item) {
      let type = 'info';
      for (let i = 0; i < this.data.length; i++) {
        if (item['value'] === this.data[i]['env']) {
          type = '';
          break;
        }
      }
      return type;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-tag {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-tag {
    margin-right: 5px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
